import isNil from 'lodash/isNil';
import capitalize from 'lodash/capitalize';
import he from 'he';

export const addCommas = (arrayOfStrings) => {
  return !Array.isArray(arrayOfStrings)
    ? arrayOfStrings
    : arrayOfStrings.filter((i) => i).join(', ');
};

export const makeFriendly = (value) => {
  if (isNil(value)) return '';

  const spaced = value.replace(/(_)/g, ' ');
  const lowerSpaced = spaced.toLowerCase();

  return lowerSpaced.replace(/(\b[a-z])/g, (m) => capitalize(m));
};

export function addFix(value, type) {
  if (type === 'percent') {
    return value.concat('%');
  } else {
    return '$'.concat(value);
  }
}

export const getDollarFormattedText = (value) => {
  if ((!value && value !== 0) || Number.isNaN(Number.parseInt(`${value}`, 10))) {
    return '';
  }
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
  });

  return formatter.format(Number.parseInt(`${value}`, 10));
};

export function cleanUpHTMLText(htmlText, cleanPTag) {
  if (!htmlText) {
    return '';
  }
  const newText = he.decode(htmlText);

  if (cleanPTag) {
    return newText.replace('<p>', '').replace('</p>', '');
  }

  return newText;
}
